import { render, staticRenderFns } from "./ActividadResultados.vue?vue&type=template&id=256bab21&scoped=true&"
import script from "./ActividadResultados.vue?vue&type=script&lang=js&"
export * from "./ActividadResultados.vue?vue&type=script&lang=js&"
import style0 from "./ActividadResultados.vue?vue&type=style&index=0&id=256bab21&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256bab21",
  null
  
)

export default component.exports